export default ['he', {

    'rtl': true,
    'two_letter_iso_name': 'he',
    'iso_name': 'he-IL',
    'strong_side': 'right',
    'weak_side': 'left',
    'google_lang_code': 'iw',

    'activity_indicator': {
        'loading': 'טוען...',
        'saving': 'שומר...',
        'removing': 'מסיר...',
        'deleting': 'מוחק...',
        'converting': 'ממיר...',
        'loggingin': 'מתחבר...',
        'loggingout': 'מתנתק...',
        'force_logging_out': 'מנתק...',
        'nextcontact': 'מחפש את איש הקשר הבא...',
        'starting_break': 'מתחיל הפסקה...',
        'stopping_break': 'מסיים הפסקה...',
        'starting_live_listening': 'מתחיל האזנה לשלוחה...',
        'starting_live_screen_monitor': 'פותח מסך צפיה בנציג...'
    },

    'size_abbrs': {
        'b': 'בתים',
        'kb': 'ק"ב',
        'mb': 'מ"ב',
        'gb': 'ג"ב',
        'tb': 'ט"ב'
    },

    'calendar': {
        'weekdays': ['יום ראשון', 'יום שני', 'יום שלישי', 'יום רביעי', 'יום חמישי', 'יום שישי', 'יום שבת'],
        'weekdays_short': ['ראש', 'שני', 'שלי', 'רבי', 'חמי', 'ששי', 'שבת'],
        'weekdays_very_short': ['א', 'ב', 'ג', 'ד', 'ה', 'ו', 'ש'],
        'months': ['ינואר', 'פברואר', 'מרץ', 'אפריל', 'מאי', 'יוני', 'יולי', 'אוגוסט', 'ספטמבר', 'אוקטובר', 'נובמבר', 'דצמבר'],
        'months_short': ['ינו', 'פבר', 'מרץ', 'אפר', 'מאי', 'יונ', 'יול', 'אוג', 'ספט', 'אוק', 'נוב', 'דצמ'],
        'today': 'היום',
        'close': 'סגור'
    },

    'date_formats': {
        'normal_date': 'dd/MM/yy',
        'short_time': 'H:mm',
        'normal_date_short_time': 'dd/MM/yy H:mm',
        'not_defined': 'לא הוגדר'
    },

    'error_codes': {
        '0-network-error': 'שגיאת רשת!',
        'not-found': 'המשאב שביקשת אינו קיים.',
        'not-allowed': 'אינך מורשה לבצע פעולה זו.',
        'authorization-error': 'עליך להתחבר למערכת על מנת לבצע פעולה זו.',
        'invalid-email': 'כתובת האימייל שסופקה אינה תקינה.',
        'username-in-use': 'שם המשתמש שסופק הינו כבר בשימוש.',
        'email-in-use': 'כתובת האימייל שסופקה הינה כבר בשימוש.',
        'empty-file': 'הקובץ שהועלה הינו קובץ ריק.',
        'ami-trouble': 'שגיאת מרכזיה, נא לפנות למנהל המערכת.',
        '403-no-match': 'שם המשתמש או הסיסמא אינם תואמים.',
        '403-locked': 'חשבונך נעול. נא צור קשר עם מנהל המערכת שלך.',
        '403': 'אינך מורשה לבצע פעולה זו.',
        '400': 'בקשה לא תקינה נשלחה אל השרת. נא צור קשר עם מנהל המערכת שלך, או נסה שוב.',
        '401': 'עליך להתחבר למערכת על מנת לבצע פעולה זו.',
        '402': 'הפעולה נדחתה על ידי השרת עקב תשלומים ממתינים.',
        '404': 'המשאב שביקשת אינו קיים.',
        '405': 'בקשה לא תקינה נשלחה אל השרת. נא צור קשר עם מנהל המערכת שלך, או נסה שוב.',
        '500': 'אירעה שגיאת שרת פנימית. נא צור קשר עם מנהל המערכת שלך, או נסה שוב.',
        '501': 'בקשה לא מוכרת נשלחה אל השרת. נא צור קשר עם מנהל המערכת שלך, או נסה שוב.',
        '502': 'נראה שאתה משתמש בשרת Proxy כושל. נא צור קשר עם מנהל המערכת שלך, או נסה שוב.',
        '503': 'השירות אינו זמין כרגע. נא צור קשר עם מנהל המערכת שלך, או נסה שוב.',
        '504': 'נראה שאתה משתמש בשרת Proxy כושל. נא צור קשר עם מנהל המערכת שלך, או נסה שוב.',
        'default': 'אירעה שגיאה לא מוכרת. נא צור קשר עם מנהל המערכת שלך, או נסה שוב.'
    },

    'filters': {
        'add_filter': 'הוספת מסנן',
        'name': 'שם',
        'manager': 'מנהל',
        'is_active': 'האם פעיל?',
        'created_at': 'תאריך יצירה',
        'updated_at': 'עדכון אחרון',
        'assigned_at': 'שיבוץ אחרון',
        'email_address': 'כתובת אימייל',
        'project': 'פרויקט',
        'product': 'מוצר',
        'campaign': 'קמפיין',
        'team_heads': 'ראשי צוות',
        'idt': 'מספר מזהה',
        'first_name': 'שם פרטי',
        'last_name': 'שם משפחה',
        'role': 'תפקיד',
        'username': 'כינוי',
        'phone_extension': 'מספר שלוחה',
        'job_start': 'תחילת עבודה',
        'description': 'תיאור',
        'from_email': 'כתובת אימייל השולח',
        'last_status_change': 'שינוי סטטוס אחרון',
        'start_date': 'תאריך תחילה',
        'end_date': 'תאריך סיום',
        'end_reason': 'סיבת סיום',
        'continue_reason': 'סיבת המשך',
        'team': 'צוות',
        'user': 'משתמש',
        'user_representative': 'נציג',
        'date': 'תאריך',
        'lead_provider_user_team': 'צוות הספק',
        'assigned_to': 'הוקצה לנציג',
        'next_action': 'פעולה הבאה'
    },

    'filter_condition': {
        '=': 'שווה ל-',
        '>': 'גדול מ-',
        '<': 'קטן מ-',
        '!=': 'שונה מ-',
        '>=': 'גדול או שווה ל-',
        '<=': 'קטן או שווה ל-',
        '<>': 'בין-',
        '-24:0H': '24 שעות אחרונות',
        '0:1d': 'היום',
        '-1:0d': 'אתמול',
        '-6:1d': '7 ימים אחרונים',
        '-29:1d': '30 ימים אחרונים',
        '0:1w': 'שבוע נוכחי',
        '-1:0w': 'שבוע שעבר',
        '0:1m': 'חודש נוכחי',
        '-1:0m': 'חודש שעבר'
    },

    'filter_condition_order': [
        '0:1d', '-1:0d',
        '0:1w', '-1:0w',
        '0:1m', '-1:0m',
        '-24:0H',
        '-6:1d', '-29:1d',
        '=', '>', '<', '!=', '>=', '<=','<>'
    ],

    'filter_date_options': {
        'today': 'היום',
        'yesterday': 'אתמול'
    },

    'filter_option_no_campaign': 'ללא קמפיין',
    'filter_option_any_campaign': 'משויך לקמפיין',

    'export_options': {
        'csv': 'CSV',
        'xml': 'XML (Excel)'
    },

    'main_nav': {
        'welcome_male': 'ברוך הבא<br />{{name}}!',
        'welcome_female': 'ברוכה הבאה<br />{{name}}!',
        'welcome': 'ברוך/ה הבא/ה<br />{{name}}!',

        'leads': 'לידים',
        'realtime': 'זמן אמת',
        'reports': 'דו״חות',
        'management': 'ניהול',
        'recordings': 'הקלטות',
        'logout': 'יציאה'
    },

    'side_nav': {
        'managements': {
            'settings': 'הגדרות',
            'projects': 'פרויקטים',
            'roles': 'תפקידים',
            'teams': 'צוותים',
            'users': 'משתמשים',
            'lead_providers': 'ספקי לידים',
            'general': 'כללי'
        },

        'reports': {
            'pick_report_message': 'בחר דו"ח מתפריט הצד',
            'call_events': 'דו״ח ארועים',
            'realtime_userinfo': 'דו״ח נציגים זמן אמת',
            'userinfo': 'דו״ח נציגים',
            'call_history': 'דו"ח הסטוריית שיחות',
            'orders': 'דו"ח הזמנות',
            'campaigns': 'מצב קמפיינים',
        },

        'leads': {
            'assign': 'שיוך לידים קיימים',
            'manual_entry': 'הזנת ליד ידני'
        }
    },

    'login': {
        'title': 'כניסה למערכת',
        'extension_title': 'בחר שלוחה',
        'username': 'שם משתמש:',
        'password': 'סיסמא:',
        'submit': 'המשך >'
    },

    'order_statuses': {
        'open': 'פתוח',
        'closed': 'סגור'
    },

    'call_types': {
        'outgoing': 'שיחה יוצאת',
        'initiated': 'שיחה יזומה',
        'predictive': 'חייגן אוטומטי',
        'incoming': 'שיחה נכנסת',
        'override': 'באנר'
    },

    'call_actions': {
        'continue': 'חזרה לאיש קשר בעתיד',
        'end': 'סיום תהליך'
    },

    'call_history_statuses': {
        'dialing': "מחייג",
        'answered': "נענה",
        'busy': "תפוס",
        'noanswer': "אין מענה",
        'denied': "נדחה",
        'failed': "נכשל",
        'cancelled': "בוטל",
        'abandoned': 'ננטש',
    },

    'contact_fields': {
        'section_basic': 'כללי',
        'section_contact': 'פרטי יצירת קשר',
        'section_comments': 'הערות',
        'section_more': 'שדות נוספים',
        'all_phones': 'כל הטלפונים',

        'title': 'תואר',
        'gender': 'מין',
        'idt': 'מספר מזהה',
        'first_name': 'שם פרטי',
        'last_name': 'שם משפחה',
        'company': 'חברה',
        'website_url': 'אתר',
        'birthdate': 'תאריך לידה',
        'phone': 'טלפון',
        'phone2': 'טלפון 2',
        'phone3': 'טלפון 3',
        'phone4': 'טלפון 4',
        'fax': 'פקס',
        'email': 'אימייל',
        'comment': 'הערות',
        'address_country': 'כתובת - ארץ',
        'address_state': 'כתובת - מדינה',
        'address_city': 'כתובת - עיר',
        'address_street': 'כתובת - רחוב',
        'address_street_number': 'כתובת - מס\' בית',
        'address_postal_code': 'כתובת - מיקוד',
        'address2_country': 'כתובת 2 - ארץ',
        'address2_state': 'כתובת 2 - מדינה',
        'address2_city': 'כתובת 2 - עיר',
        'address2_street': 'כתובת 2 - רחוב',
        'address2_street_number': 'כתובת 2 - מס\' בית',
        'address2_postal_code': 'כתובת 2 - מיקוד',

        'address': 'כתובת',
        'address2': 'כתובת נוספת',
        'country': 'ארץ',
        'state': 'מדינה',
        'city': 'עיר',
        'street': 'רחוב',
        'street_number': 'מס\' בית',
        'postal_code': 'מיקוד',

        'assign_to_campaign': 'שייך לקמפיין',
        'campaign_next_action': {
            'call': 'ממתין לחלוקה',
            'continue': 'שיחה חוזרת',
            'end': 'סיים תהליך'
        }
    },

    'genders': {
        '': '',
        'male': 'זכר',
        'female': 'נקבה'
    },

    'order_fields': {
        'id': 'מזהה הזמנה',
        'product_id': 'מזהה מוצר',
        'campaign_id': 'מזהה קמפיין',
        'contact_id': 'מזהה איש קשר',
        'contact_name': 'שם איש קשר',
        'status': 'מצב הזמנה',
        'created_at': 'נוצר בתאריך',
        'created_by': 'נוצר על ידי',
        'updated_at': 'עודכן בתאריך',
        'closed_at': 'נסגר בתאריך',
        'closed_by': 'נסגר על ידי'
    },

    'general_settings': {
        'title': 'הגדרות כלליות',

        'tab_projects': {
            'title': 'פרויקטים',
            'continue_reasons': 'סיבות המשך תהליך',
            'end_reasons': 'סיבות סיום תהליך'
        },

        'tab_calls': {
            'title': 'שיחות'
        }
    },

    'projects_list': {
        'title': 'רשימת פרויקטים',
        'new_project': 'פרויקט חדש',
        'general_settings': 'הגדרות כלליות',

        'columns': {
            'id': 'ID',
            'name': 'שם',
            'manager': 'מנהל פרויקט',
            'is_active': 'פעיל?',
            'created_at': 'תאריך יצירה',
            'updated_at': 'עדכון אחרון',
            'actions': 'פעולות'
        },

        'delete_project_prompt': 'האם ברצונך למחוק את הפרויקט?\nפעולה זו תמחק כל מידע הקשור בפרויקט, כולל קמפיינים, אנשי קשר וכו\''
    },

    'recordings_list': {
        'title': 'הקלטות',

        'columns': {
            'calldate': 'תאריך/שעה',
            'uniqueid': 'מזהה',
            'destination': 'מספר טלפון',
            'channel': 'שלוחה',
            'total_duration': 'משך שיחה כולל',
            'call_duration': 'משך שיחה לא כולל',
            'disposition': 'מצב שיחה',
            'did': 'מספר נכנס',
            'actions': 'פעולות'
        },

        'disposition_options': {
            'NO ANSWER': 'אין מענה',
            'ANSWERED': 'נענה',
            'BUSY': 'תפוס',
            'CONGESTION': 'עומס'
        }
    },

    'project_tabbed_area': {
        'project_list': 'רשימת פרויקטים',
        'edit_title': 'עריכת פרויקט',
        'new_title': 'פרויקט חדש',

        'general': 'כללי',
        'products': 'מוצרים',
        'campaigns': 'קמפיינים',
        'users': 'נציגים',
        'contacts': 'אנשי קשר וייבוא',

        'general_side_menu': {
            'general': 'הגדרות כלליות',
            'continue_reasons': 'סיבות המשך תהליך',
            'end_reasons': 'סיבות סיום תהליך',
            'contact_custom_fields': 'שדות דינמיים לאנשי קשר',
            'realtime_users_settings': 'הגדרות למסך זמן אמת',
            'advanced_settings': 'הגדרות מתקדמות',
        },

        'product_side_menu': {
            'basic': 'הגדרות',
            'order_custom_fields': 'שדות דינמיים להזמנות'
        },

        'campaign_side_menu': {
            'basic': 'הגדרות',
            'time_table': 'זמני עבודה',
            'call_settings': 'הגדרות שיחה',
            'users': 'נציגים'
        }
    },

    'project_details': {
        'title': 'הגדרות כלליות',
        'project_name': 'שם הפרויקט:',
        'project_status': 'סטטוס הפרויקט:',
        'project_mode': 'סוג הפרויקט',
        'project_manager': 'מנהל/ת הפרויקט:',
        'project_teams': 'צוותי הפרויקט:',
        'project_teams_and_heads': 'צוותי הפרויקט וראשי הצוותים:',
        'new_contact_default_campaign': 'קמפיין ברירת מחדל לאיש קשר חדש:',
        'can_user_choose_new_contact_campaign': 'אפשר בחירת קמפיין ע״י נציג ביצירת איש קשר:',
        'select_unique_field': 'בחר שדה ייחודי לבדיקת כפילויות',
        'hide_continue_by_selection': 'הסתר מהנציג בחירת המשך תהליך "על ידי"',
        'add_team_button': 'הוסף צוות חדש',
        'team_name': 'שם הצוות',
        'team_managers': 'ראשי הצוות',

        'project_statuses': {
            'active': 'פעיל',
            'inactive': 'לא פעיל'
        },

        'project_modes': {
            'internal': 'רגיל - פנימי',
            'predictive': 'חייגן אוטומטי - פנימי',
            'incoming': 'שיחות נכנסות',
            'external': 'חיצוני'
        },

        'saved_prompt': 'הפרויקט נשמר בהצלחה.',
        'default_campaign_error_prompt': 'חובה להגדיר קמפיין ברירת מחדל או לאפשר בחירת קמפיין על ידי הנציג'
    },

    'project_realtime_settings': {
        'title': 'הגדרות זמן אמת',

        'idle_duration_alert_minutes': 'התראה לאחר זמן שלא בשיחה:',
        'in_call_duration_alert_minutes': 'התראה לאחר זמן בשיחה:',
        'dialing_duration_alert_minutes': 'התראה לאחר זמן מחייג:',
        'logged_in_duration_alert_minutes': 'התראה לאחר זמן שמחובר:',

        'saved_prompt': 'הפרויקט נשמר בהצלחה.'
    },

    'project_advanced_settings': {
        'title': 'הגדרות מתקדמות',

        'hide_mapped_continue_reasons': 'הסתר סיבות המשך ממופות:',
        'hide_mapped_end_reasons': 'הסתר סיבות סיום ממופות:',
        'lock_continue_reason_id': 'נעילת סיבת המשך תהליך:',
        'lock_end_reason_id': 'נעילת סיבת סיום תהליך:',
        'custom_fields_to_display': 'שדות דינמיים להצגה במסך שיחות יוצאות:',
        'open_website_url': 'פתח לינק בכל מעבר איש קשר:',
        'auto_open_order': 'פתח הזמנה בכל מעבר איש קשר:',
        'option_no_lock': 'ללא נעילה',

        'saved_prompt': 'ההגדרות נשמרו בהצלחה',
    },

    'campaign_edit': {

        'basic': {
            'title': 'הגדרות כלליות',
            'campaign_name': 'שם הקמפיין:',
            'campaign_external_id': 'מזהה חיצוני:',
            'campaign_description': 'תיאור הקמפיין:',
            'campaign_status': 'סטטוס הקמפיין:',
            'campaign_mode': 'סוג הקמפיין:',
            'campaign_priority': 'עדיפות: <sup>ערך גבוה יותר מקבל עדיפות</sup>',
            'campaign_exclusive': 'בלעדי:',

            'duplicate': 'שכפל קמפיין',
            'new': 'קמפיין חדש',

            'saved_prompt': 'הקמפיין נשמר בהצלחה.'
        },

        'call_settings': {
            'title': 'הגדרות שיחה',
            'redial_on_noresponse_minutes': 'זמן חזרה במידה ואין מענה:',
            'redial_on_busy_minutes': 'זמן חזרה במידה ותפוס:',
            'redial_count': 'מספר פעמים לחזרה באין מענה / תפוס:',

            'saved_prompt': 'הקמפיין נשמר בהצלחה.'
        },

        'timetable': {
            'title': 'זמני עבודה',
            'timetable_always': 'פעיל תמיד',
            'day': 'יום',
            'from_time': 'התחלה',
            'to_time': 'סיום',
            'select_time': '',
            'day_names': {
                "1": "יום א'",
                "2": "יום ב'",
                "3": "יום ג'",
                "4": "יום ד'",
                "5": "יום ה'",
                "6": "שישי",
                "7": "שבת"
            },

            'saved_prompt': 'הקמפיין נשמר בהצלחה.'
        },

        'user_mapping': {
            'title': 'נציגי/ות הקמפיין',

            'mark_team_description': 'סימון<br />כל הצוות'
        },

        'broadcast_settings': {
            'title': 'הגדרות הפצה',
            'recording_filename': 'שם קובץ הקלטה:',
            'caller_id': 'זיהוי מספר טלפון:',
            'dynamic_recordings': 'הקלטה דינמית:',
            'max_call_length': 'משך שיחה מקסימלי:',
            'hangup_no_answer': 'ניתוק באין מענה לאחר:',
            'flow_name': 'מזהה תהליך:',
            'product': 'בחירת מוצר:',
            'fields_map': 'מיפוי שדות:',
            'upload': 'לחץ להעלאה',
            'upload_success': 'הקובץ נשמר בהצלחה'
        },

        'template': {
            'title': 'עריכת תבנית הפצת הודעות',
            'template_label': 'תבנית',
            'sample_label': 'תוצאה לדוגמא',
            'generate_tts': 'צור קובץ שמע',
            'render_phase2': 'ניתוח שלב 2',
            'contact_id': 'מזהה איש קשר לדוגמא',
            'warn_no_contact': 'בחר מזהה איש קשר קיים להצגת הדוגמא',
            'warn_template_error': 'שגיאה בתבנית: {{err}}',
            'warn_missing_data': 'התבנית מכילה טוקנים שאינם קיימים באיש הקשר שנבחר',
            'warn_save_campaign': 'נא לשמור את הקמפיין לפני יצירת קובץ שמע',

            'contact_fields_title': 'שם השדה',
            'contact_fields_token': 'שם טוקן',
            'contact_fields_value': 'ערך לדוגמא',

            'contact_fields': {
                'title': 'תואר',
                'gender': 'מין',
                'idt': 'מספר מזהה',
                'first_name': 'שם פרטי',
                'last_name': 'שם משפחה',
                'company': 'חברה',
                'website_url': 'אתר',
                'birthdate': 'תאריך לידה',
                'phone': 'טלפון',
                'phone2': 'טלפון 2',
                'phone3': 'טלפון 3',
                'phone4': 'טלפון 4',
                'fax': 'פקס',
                'email': 'אימייל',
                'comment': 'הערות',
                'address_country': 'כתובת - ארץ',
                'address_state': 'כתובת - מדינה',
                'address_city': 'כתובת - עיר',
                'address_street': 'כתובת - רחוב',
                'address_street_number': 'כתובת - מס\' בית',
                'address_postal_code': 'כתובת - מיקוד',
                'address2_country': 'כתובת 2 - ארץ',
                'address2_state': 'כתובת 2 - מדינה',
                'address2_city': 'כתובת 2 - עיר',
                'address2_street': 'כתובת 2 - רחוב',
                'address2_street_number': 'כתובת 2 - מס\' בית',
                'address2_postal_code': 'כתובת 2 - מיקוד',
            }
        },

        'import_from_campaign': 'ייבוא שדות מקמפיין אחר',
        'back': 'חזרה לקמפיינים'

    },

    'call_settings': {
        'red_subtitle': 'הגדרת כמות זמן לאזהרה',
        'red_description': '* לאחר כמה זמן, השדה מופיע בצבע אדום',

        'red_time_call': 'זמן שיחה:',
        'red_hold_call': 'החזקת שיחה:',
        'red_without_call': 'ללא שיחה:',
        'red_mute_call': 'השתק:',

        'reasons_subtitle': 'סיבות המשך וסיום תהליך',
        'reasons_description': 'לבחירה אוטומטית לאחר נסיון שיחה',

        'busy_continue_reason': 'המשך תהליך - תפוס',
        'busy_end_reason': 'סיום תהליך - תפוס',
        'noresponse_continue_reason': 'המשך תהליך - אין מענה',
        'noresponse_end_reason': 'סיום תהליך - אין מענה',
        'wrongnumber_end_reason': 'סיום תהליך - מספר שגוי',
        'answered_continue_reason': 'המשך תהליך - שיחה נענתה',
        'answered_end_reason': 'סיום תהליך - שיחה נענתה',

        'saved_prompt': 'ההגדרות נשמרו בהצלחה.'
    },

    'permissions': {
        'admin': 'מנהל',
        'representative': 'נציג',

        'edit_general_settings': 'עריכת הגדרות כלליות',

        'delete_contact': 'אנשי קשר - מחיקה',

        'delete_project': 'פרויקטים - מחיקה',
        'edit_project': 'פרויקטים - עריכה',
        'new_project': 'פרויקטים - יצירה',

        'delete_role': 'תפקידים - מחיקה',
        'edit_role': 'תפקידים - עריכה',
        'new_role': 'תפקידים - יצירה',

        'delete_team': 'צוותים - מחיקה',
        'edit_team': 'צוותים - עריכה',
        'new_team': 'צוותים - יצירה',

        'delete_user': 'משתמשים - מחיקה',
        'edit_user': 'משתמשים - עריכה',
        'new_user': 'משתמשים - יצירה',
        'import_users': 'ייבוא משתמשים',

        'delete_lead_provider': 'ספקי לידים - מחיקה',
        'edit_lead_provider': 'ספקי לידים - עריכה',
        'new_lead_provider': 'ספקי לידים - יצירה',

        'leads': 'לידים - צפייה',
        'assign_leads': 'לידים - שיוך',
        'delete_leads': 'לידים - מחיקה',

        'recordings_client': 'לקוח הקלטות',
        'recordings_admin': 'מנהל הקלטות',
        'recordings_stream': 'גישה ישירה להקלטה',

        "reports_live_listening": 'דו"חות - האזנה בזמן אמת',
        "reports_live_screen_monitor": 'דו"חות - צפיה במסך נציג',

        'reports_call_sessions': 'דו״חות - ארועים',
        'reports_realtime_userinfo': 'דו״חות - נציגים זמן אמת',
        'reports_userinfo': 'דו״חות - נציגים',
        'reports_call_history': 'דו"חות - הסטוריית שיחות',
        'reports_orders': 'דו"חות - הזמנות',
        'reports_campaigns': 'מצב קמפיינים'
    },

    'roles_list': {
        'title': 'ניהול תפקידים',
        'new_role': 'תפקיד חדש',

        'columns': {
            'description': 'תיאור',
            'name': 'שם ',
            'actions': 'פעולות'
        },

        'delete_role_prompt': 'האם ברצונך למחוק את התפקיד?\nפעולה זו תמחק כל מידע הקשור בתפקיד'
    },

    'role_details': {
        'new_role': 'תפקיד חדש',
        'role_list': 'רשימת תפקידים',
        'description': 'תיאור:',
        'name': 'שם פנימי: <sup>(ייחודי, לא משתנה)</sup>',
        'manage_permissions': 'ניהול הרשאות:',

        'saved_prompt': 'התפקיד נשמר בהצלחה.'
    },

    'teams_list': {
        'title': 'ניהול צוותים',
        'new_team': 'צוות חדש',

        'columns': {
            'name': 'שם',
            'heads': 'ראשי צוות',
            'status': 'סטטוס צוות',
            'link': 'שיוך לפרויקט',
            'actions': 'פעולות'
        },

        'delete_team_prompt': 'האם ברצונך למחוק את הצוות?\nפעולה זו תמחק כל מידע הקשור בצוות'
    },

    'team_tabbed_area': {
        'team_list': 'רשימת צוותים',
        'edit_title': 'עריכת צוות',
        'new_title': 'צוות חדש',

        'general': 'כללי',
        'users': 'נציגים'
    },

    'team_details': {
        'title': 'הגדרות כלליות',
        'team_name': 'שם הצוות:',
        'team_project': 'שיוך לפרויקט:',
        'team_heads': 'ראשי הצוות:',
        'add_team_heads_button': 'הוסף ראשי צוותים',

        'saved_prompt': 'הצוות נשמר בהצלחה.'
    },

    'team_users': {
        'title': 'נציגי הצוות',
        'team_name': 'שם הצוות:',
        'add_team_users_button': 'הוספת נציג/ה',

        'saved_prompt': 'הצוות נשמר בהצלחה.'
    },

    'users_list': {
        'title': 'ניהול משתמשים',
        'new_user': 'משתמש חדש',
        'import_users': 'ייבוא משתמשים',

        'columns': {
            'first_name': 'שם פרטי',
            'last_name': 'שם משפחה',
            'role':'סוג משתמש',
            'username':'שם משתמש',
            'project_name': 'פרויקט',
            'password':'סיסמה',
            'last_phone_extension':'מס שלוחה אחרונה',
            'job_start_date':'תאריך תחילת עבודה',
            'team':'שיוך לצוות',
            'is_active':'סטטוס',
            'actions': 'פעולות'
        },

        'delete_user_prompt': 'האם ברצונך למחוק את המשתמש?\nפעולה זו תמחק כל מידע הקשור בו'
    },

    'user_details': {
        'new_user': 'משתמש חדש',
        'user_list': 'רשימת משתמשים',

        'user_details':'פרטי משתמש' ,
        'personal_details': 'פרטים אישיים',
        'general_details': 'מידע כללי',

        'username':'שם משתמש:',
        'password':'סיסמה:',
        'role':'סוג משתמש:',
        'team':'שיוך לצוות:',
        'project':'שיוך לפרויקט:',
        'status':'סטטוס:',

        'first_name': 'שם פרטי:',
        'last_name': 'שם משפחה:',
        'idt': 'ת"ז:',
        'birthdate': 'תאריך לידה:',
        'gender': 'מין:',
        'address': 'כתובת:',
        'phone': 'טלפון:',
        'phone2': 'טלפון נוסף:',
        'external_id': 'מזהה חיצוני:',
        'work_email': 'דוא"ל עבודה:',
        'job_start': 'תאריך תחילת עבודה:',
        'job_end': 'תאריך סיום עבודה:',
        'clock_number': 'מספר שעון:',
        'hourly_rate': 'שכר שעתי:',
        'phone_extension': 'מספר שלוחה:',
        'last_phone_extension': 'מספר שלוחה אחרון:',
        'personal_break_minutes': 'מספר דקות להפסקה אישית:',
        'comment': 'הערות:',

        'recordings_access': {
            'title': 'גישה להקלטות',
            'add': 'הוסף גישה',
            'from_channel': 'שלוחה:',
            'to_channel': 'עד שלוחה:',
            'userfield': 'userfield:',
            'from_date': 'תאריך:',
            'to_date': 'עד תאריך:'
        },

        'user_statuses': {
            'active': 'פעיל',
            'inactive': 'לא פעיל'
        },

        'saved_prompt': 'המשתמש נשמר בהצלחה.'
    },

    'import_users_page': {
        'title': 'ייבוא משתמשים',
        'process_button': 'הפקת דו"ח ייבוא',
        'import_button': 'בצע ייבוא',
        'stop_import': 'עצור ייבוא',
        'completed_prompt': 'הייבוא הסתיים בהצלחה, {{count}} משתמשים יובאו.',
        'ready_to_import': 'מוכנים לייבוא',
        'imported': 'יובאו בהצלחה',
        'imported_errors': 'שגיאות ייבוא',
        'total_in_file': 'סך הכל בקובץ',
        'columns': {
            'type': 'סוג רשומה',
            'errors': 'שגיאות',
            'result': 'תוצאת ייבוא',
        },
        'column_types': {
            'new': 'חדשה',
            'update': 'עדכון',
        },
        'errors': {
            'template_mismatch': 'התבנית שנבחרה אינה תואמת למבנה הקובץ!',
            'missing_required_fields': 'חסר שדות נדרשים',
            'id_not_found': 'לא נמצא מזהה תואם',
            'team_not_found': 'לא נמצא צוות',
            'project_not_found': 'מזהה פרויקט לא קיים',
            'username_already_exist': 'שם משתמש כבר קיים',
            'team_match_to_id_and_name': 'עמודת צוות תואמת גם למזהה וגם לשם'
        },
        'result': {
            'success': 'יובא בהצלחה',
            'error': 'ייבוא נכשל',
            'skipped': 'מדלג'
        }
    },

    'user_fields': {
        'id': 'מזהה פנימי',
        'project_id': 'פרויקט',
        'team_id': 'צוות',
        'username': 'שם משתמש',
        'password': 'סיסמה',
        'idt': 'ת"ז',
        'first_name': 'שם פרטי',
        'last_name': 'שם משפחה',
        'birthdate': 'תאריך לידה',
        'gender': 'מין',
        'address': 'כתובת',
        'phone': 'טלפון',
        'phone2': 'טלפון נוסף',
        'work_email': 'דוא"ל עבודה',
        'job_start': 'תאריך תחילת עבודה',
        'clock_number': 'מספר שעון',
        'hourly_rate': 'שכר שעתי',
        'comment': 'הערות',
        'personal_break_minutes': 'מספר דקות להפסקה אישית',
        'is_active': 'האם פעיל',
        'external_id': 'מזהה חיצוני',
    },

    'continue_reasons': {
        'title': 'סיבות המשך תהליך',
        'add_row_button': 'הוספת סיבה',
        'saved_prompt': 'הסיבות נשמרו בהצלחה.'
    },

    'end_reasons': {
        'title': 'סיבות סיום תהליך',
        'add_row_button': 'הוספת סיבה',
        'saved_prompt': 'הסיבות נשמרו בהצלחה.'
    },

    'generic_prompts': {
        'confirm_leave_unsaved': 'האם ברצונך לעזוב את מצב העריכה ולבטל שינויים שלא נשמרו?'
    },

    'custom_fields': {
        'title_edit': 'עריכת שדה',
        'title_new': 'שדה חדש',

        'field_types': {
            'text': 'שדה טקסט',
            'multiline': 'טקסט חופשי',
            'checkbox': 'כן / לא',
            'checkboxlist': 'בחירה מרובה',
            'radio': 'בחירה',
            'dropdown': 'תיבה נפתחת'
        },

        'custom_field_subtype': {
            'plain': 'פשוט',
            'date': 'תאריך',
            'tel': 'טלפון'
        },

        'row_labels': {
            'required': 'שדה חובה:',
            'readonly': 'קריאה בלבד:',
            'name': 'שם השדה:',
            'explain': 'הסבר: <i>(לא חובה)</i>',
            'subtype': 'סוג השדה:',
            'contact_source_field': 'שדה למשיכה מאיש קשר:',
            'options': 'אפשרויות:',
            'condition': 'התניה:'
        },

        'group_basic_fields': 'שדות בסיסיים',
        'group_custom_fields': 'שדות דינמיים',
        'add_option_button': 'הוסף אפשרות'
    },

    'project_contact_fields': {
        'title': 'שדות דינמיים לאנשי קשר',
        'add_field_button': 'הוספת שדה',
        'saved_prompt': 'השדות נשמרו בהצלחה.'
    },

    'product_order_fields': {
        'title': 'שדות דינמיים להזמנות',
        'add_field_button': 'הוספת שדה',
        'saved_prompt': 'השדות נשמרו בהצלחה.',
        'copyable': 'שימור בשכפול:'
    },

    'products_list': {
        'title': 'רשימת מוצרים',
        'new_product': 'מוצר חדש',

        'columns': {
            'id': 'ID',
            'name': 'שם',
            'is_active': 'המוצר פעיל?',
            'created_at': 'תאריך יצירה',
            'updated_at': 'עדכון אחרון',
            'actions': 'פעולות'
        },

        'delete_product_prompt': 'האם ברצונך למחוק את המוצר?\nפעולה זו תמחק כל מידע הקשור במוצר, כולל הזמנות וכו\''
    },

    'product_details': {
        'title_new': 'מוצר חדש',
        'title_edit': 'עריכת מוצר',
        'product_name': 'שם המוצר:',
        'is_active': 'המוצר פעיל:',

        'saved_prompt': 'המוצר נשמר בהצלחה.'
    },

    'campaigns_list': {
        'title': 'רשימת קמפיינים',
        'new_campaign': 'קמפיין חדש',

        'exclusive': 'בלעדי',

        'columns': {
            'name': 'שם',
            'priority': 'עדיפות',
            'status': 'סטטוס',
            'mode': 'סוג',
            'teams': 'צוות',
            'created_at': 'תאריך יצירה',
            'updated_at': 'עדכון אחרון',
            'actions': 'פעולות'
        },

        'delete_campaign_prompt':  'האם אתה בטוח שברצונך למחוק את הקמפיין?\nפעולה זו תמחק כל מידע הקשור בקמפיין, כולל הזמנות וכו\''
    },

    'contact_list': {
        'title': 'רשימת אנשי קשר',
        'new_contact': 'איש קשר חדש',
        'export_to_campaign': 'שיוך אנשי קשר לקמפיין<br /><small>(לפי סינון נוכחי)</small>',
        'import_data': 'ייבוא DATA חדש',
        'details': 'פרטים',

        'columns': {
            'campaign_name': 'משויך לקמפיין',
            'created_at': 'תאריך יצירה',
            'updated_at': 'עדכון אחרון',
            'is_active': 'האם פעיל?',
            'actions': 'פעולות',

            'campaign_comment': 'הערות שיחה אחרונה',
            'campaign_continue_reason': 'סיבת המשך תהליך אחרונה',
            'campaign_end_reason': 'סיבת סיום תהליך אחרונה',
            'campaign_next_action': 'פעולה הבאה',
            'campaign_next_action_when': 'תאריך פעולה הבאה',
            'campaign_continue_by': 'משויך לנציג',
            'campaign_answered_call_count': 'מספר שיחות שנענו',
            'call_session_last_start_time': 'תאריך תהליך אחרון',
            'call_session_user': 'נציג שביצע תהליך אחרון',
        },

        'delete_contact_prompt': 'פעולה זו תמחק כל מידע הקשור באיש הקשר\nהאם אתה בטוח שברצונך למחוק את איש הקשר?'
    },

    'new_edit_contact': {
        'new_title': 'הקמת איש קשר חדש',
        'view_title': 'פרטי איש קשר'
    },

    'import_contacts_page': {
        'title': 'ייבוא נתוני אנשי קשר'
        , 'title_2nd_phase': 'דו"ח ייבוא וטיפול בשגיאות'

        , 'import_button': 'הפקת דוח ייבוא >'

        , 'import_status_zero': 'מעבד את נתוני הייבוא...'
        , 'import_status': 'מעבד את נתוני הייבוא... ({{count}})'

        , 'action_cancel_import': 'ביטול תהליך'
        , 'action_continue_import': 'ייבוא >'

        , 'settings_title': 'הגדרות עדכון שדות'
        , 'settings_field': 'שדה'
        , 'settings_add': 'הוסף'
        , 'settings_update': 'עדכן'
        , 'settings_delete': 'מחק'

        , 'status_errors': 'שגיאות'
        , 'status_duplicates': 'כפילויות'
        , 'status_new': 'חדשים'
        , 'status_total': 'סה"כ'
        , 'status_pending': 'לטיפול:'
        , 'status_selected': 'לייבוא:'
        , 'status_imported': 'יובאו:'

        , 'tab_errors': 'שגיאות'
        , 'tab_duplicates': 'כפולים'
        , 'tab_new': 'חדשים'
        , 'tab_imported': 'יובאו'
        , 'tab_importedDuplicates': 'כפילויות מקומיות'

        , 'tab_action_select': 'בחר'
        , 'tab_errors_column': 'פירוט שגיאות'

        , 'error_tab_reasons': {
            'unknown': 'לא ידועה'
            , 'too_long': 'שדה ארוך מדי'
            , 'duplicate': 'כפילות'
            , 'missing_phone_or_email': 'חסר טלפון או כתובת מייל'
            , 'missing_basic_info': 'חסר פרטים מזהים'
        }

        , 'error_generic_failure': 'תהליך הייבוא נכשל מסיבה לא ידועה.'
        , 'error_no_contacts': 'תהליך הייבוא נכשל, לא נמצאו אנשי קשר.'
        , 'warn_imported_duplicates': 'נמצאו {{number}} כפילויות בתוך הרשומות עצמן'
        , 'completed_prompt': 'הייבוא הסתיים בהצלחה, {{count}} אנשי קשר יובאו.'
    },

    'select_import_template': {
        'ignore_duplicates': 'התעלם מכפילויות'
        , 'template_select': 'בחירת תבנית'
        , 'new_template': 'תבנית חדשה'
        , 'edit_template': 'צפיה / עריכה'
        , 'delete_template': 'מחיקת תבנית'
        , 'delete_template_prompt': 'האם אתה בטוח שברצונך למחוק את התבנית?'
        , 'import_file': 'בחר קובץ לייבוא'
    },
    'edit_import_template_popup': {
        'new_title': 'תבנית חדשה'
        , 'edit_title': 'עריכת תבנית'

        , 'name': 'שם התבנית'
        , 'load_file_label': 'טעינת דוגמא מקובץ קיים'

        , 'label': 'כותרת מהקובץ'
        , 'sample_value': 'ערך לדוגמא'
        , 'field': 'שיוך לשדה'
        , 'format': 'פורמט'

        , 'saved_prompt': 'התבנית נשמרה בהצלחה.'
    },

    'file_controls': {

        'file_choose': {
            'm': 'בחר קובץ...'
            , 'f': 'בחרי קובץ...'
            , '': 'בחירה...'
        }

        , 'drop_file_description': {
            'male': 'שחרר את הקובץ כאן...'
            , 'female': 'שחררי את הקובץ כאן...'
            , '': 'שחרר/י את הקובץ כאן...'
        }

    },

    'lead_providers_list': {
        'title': 'ספקי לידים ותבניות',
        "new_lead_provider": 'ספק חדש',

        'columns': {
            'id': 'ID',
            'name': 'שם',
            'project': 'פרויקט',
            'campaign': 'קמפיין',
            'email_address': 'כתובת מייל',
            'is_active': 'פעיל?',
            'actions': 'פעולות'
        },

        'delete_provider_prompt': 'האם ברצונך למחוק את הספק?\nפעולה זו תמחק כל מידע הקשור הספק, כולל לידים וכו\'\nאנשי קשר אשר נוצרו מלידים אלו לא יימחקו.'
    },

    'lead_provider_details': {
        'title_edit': 'עריכת ספק לידים',
        'title_new': 'ספק לידים חדש',

        'name': 'שם הספק:',
        'project': 'שיוך לפרויקט:',
        'campaign': 'שיוך לקמפיין:',
        'campaign_none': 'ללא קמפיין (לא פעיל)',
        'email_address': 'כתובת אימייל: (ניתן להפריד בנקודה-פסיק)',
        'status': 'סטטוס:',
        'fields': 'שדות:',
        'fields_pre': 'מילה לפני:',
        'fields_suf': 'מילה אחרי:',
        'fields_contact_dest_field': 'מיפוי לשדה:',

        'fields_add_row': 'הוספת שורה:',

        'lead_provider_statuses': {
            'active': 'פעיל',
            'inactive': 'לא פעיל'
        },

        'saved_prompt': 'הספק נשמר בהצלחה.'
    },

    'leads_list': {
        'new': 'לידים חדשים',
        'error': 'לידים שגיאות',
        'assigned': 'לידים שהוקצו לנציגים',
        'inprogress': 'לידים שהתחילו תהליך',
        'done': 'לידים שטופלו',

        'tab_new': 'חדשים',
        'tab_error': 'שגיאות',
        'tab_assigned': 'הוקצה לנציג',
        'tab_inprogress': 'התחילו תהליך',
        'tab_done': 'טופלו',

        'columns': {
            'created_at': 'זמן יצירה',
            'assigned_at': 'שיבוץ אחרון',
            'updated_at': 'עדכון אחרון',
            'from': 'מאת',
            'lead_provider': 'זיהוי ספק',
            'project': 'פרויקט',
            'campaign': 'קמפיין',
            'errors': 'שגיאות',
            'assigned': 'הוקצה לנציג',

            'actions': {
                'title': 'פעולות',
                'contact_info_title': 'כרטיס איש קשר',
                'more_details': 'פרטים נוספים',
                'assign': 'שיבוץ',
                'add': 'הוספה'
            }
        },

        'delete_lead_prompt': 'האם ברצונך למחוק את הליד?\nפעולה זו תמחק כל מידע הקשור בליד\'',
        'added_lead_prompt': 'הליד נוסף בהצלחה.',

        'errors_column_format': 't("leads_list.errors_column_format_leads", {"count": {{leads_count}}, "contacts_count": {{contacts_count}}})',
        'errors_column_format_leads_zero': 't("leads_list.errors_column_format_contacts", {"count": {{contacts_count}}})',
        'errors_column_format_leads': 't("leads_list.errors_column_format_leads_contacts", {"leads_count": {{count}}, "count": {{contacts_count}}})',
        'errors_column_format_leads_contacts_zero': '{{leads_count}} לידים כפולים',
        'errors_column_format_leads_contacts': '{{leads_count}} לידים כפולים, {{count}} אנשי קשר כפולים',
        'errors_column_format_contacts_zero': '',
        'errors_column_format_contacts': '{{count}} אנשי קשר כפולים',

        'error_duplicate_against_format': '{{record_type}} t("leads_list.duplicate", {"gender": "{{record_type_gender}}"}) מול {{field}} מס\' {{record_id}}',

        'error_record_type_lead': [
            'ליד'
            , 'male'
        ],
        'error_record_type_contact': [
            'איש קשר'
            , 'male'
        ],

        'duplicate': {
            'm': 'כפול',
            'f': 'כפולה'
        }
    },

    'lead_details': {
        'title': 'פרטי הליד'
    },

    'lead_manual_entry_page': {
        'title': 'הזנת ליד ידני',

        'team': 'צוות',
        'user': 'נציג',
        'campaign': 'שיוך לקמפיין',

        'saved_prompt': 'הליד נוצר בהצלחה'
    },

    'assign_lead_popup': {
        'title': 'שיוך ליד',

        'columns': {
            'name': 'שם',
            'count_leads': 'לידים שחולקו היום',
            'assign': 'שיוך'
        },

        'assign_action': 'שיבוץ >',

        'saved_prompt': 'השיוך התבצע בהצלחה!'
    },

    'contact_reassign_options_popup': {
        'title': 'טיפול באיש קשר משויך',
        'title_count': 'טיפול ב-{{count}} אנשי קשר משויכים',

        'ignore_conflict_and_reassign': 'התעלם מתהליך קיים ושבץ מחדש',
        'end_reason_reassign': 'סיים תהליך קיים...',
        'end_reason': 'סיבת סיום תהליך',

        'contact_name': 'שם איש קשר',
        'campaign_name': 'שם קמפיין'
    },

    'export_to_campaign_popup': {
        'title': 'שיוך אנשי קשר לקמפיין',

        'new': 'קמפיין חדש',
        'existing': 'קמפיין קיים',
        'campaign_name_placeholder': 'שם הקמפיין',
        'saved_prompt': 'השיוך הושלם בהצלחה.'
    },

    'contact_popup': {
        'title_format': '<span>כרטיס איש קשר:</span> <b>{{name}}</b>',
        'title_new': 'הקמת איש קשר חדש',
        'tab_profile': 'פרטי איש קשר',
        'tab_lead': 'פרטי ליד',
        'tab_call_history': 'היסטוריית אירועים',
        'tab_orders': 'הזמנות',

        'contact': {
            'title': 'פרטי איש הקשר'
        },

        'call_sessions': {
            'title': 'היסטוריית אירועים',
            'type': 'סוג',
            'date': 'תאריך',
            'time': 'שעה',
            'project': 'פרויקט',
            'campaign': 'קמפיין',
            'user': 'נציג/ה',
            'action': 'פעולה',
            'reason': 'פרטים',
            'comment': 'הערות'
        },

        'call_history': {
            'title': 'שיחות באירוע',
        },

        'last_orders': {
            'title': 'דו"ח מכירות',
            'date': 'תאריך',
            'time': 'שעה',
            'user': 'נציג/ה',
            'campaign': 'קמפיין',
            'product': 'מוצר',
            'order': 'הזמנה מס\'',
            'status': 'סטטוס',
            'comment': 'הערות'
        }
    },

    'campaign_status': {
        'active': "פעיל",
        'inactive': "לא פעיל",
        'returns_only': "חזרות בלבד",
        'new_only': "חדשים בלבד"
    },

    'campaign_mode': {
        'outgoing': "יוצאות",
        'incoming': "נכנסות",
        'outgoing_incoming': "יוצאות ונכנסות",
        'voice_broadcast': "הפצת הודעות"
    },

    'time_units': {
        'hours': 'שעות',
        'minutes': 'דקות',
        'seconds': 'שניות'
    },

    'import_from_entity_popup': {
        'name': 'שם',
        'actions': '',
        'import': 'בחר לייבוא'
    },

    'call_events_report': {
        'title': 'דו״ח ארועים',
        'join_contact_fields': 'ייצוא כל השדות הקבועים',
        'only_last': 'הצג רק אירוע אחרון',

        'filters': {
            'type': 'סוג ארוע',
            'status': 'סטטוס',
            'contact_phones': 'טלפון של איש קשר',
            'dialed_phone': 'טלפון שחויג',
            'contact_id': 'מזהה איש קשר',
            'session_id': 'מזהה אירוע'
        },

        'type_options': {
            'outgoing': 'שיחה יוצאת',
            'initiated': 'שיחה יזומה',
            'predictive': 'חייגן אוטומטי',
            'incoming': 'שיחה נכנסת',
            'override': 'באנר'
        },

        'status_options': {
            'inprogress': 'בתהליך',
            'ended': 'הסתיים'
        },

        'field_labels': {
            'campaign': 'קמפיין:',
            'start_time': 'תאריך תחילה:',
            'end_time': 'תאריך סיום:',
            'contact': 'איש קשר:',
            'user': 'נציג:',
            'type': 'סוג:',
            'status': 'סטטוס:',
            'continue_reason': 'סיבת המשך תהליך:',
            'continue_by': 'המשך ע״י:',
            'end_reason': 'סיבת סיום תהליך:',
            'comment': 'הערות:'
        },

        'columns': {
            'contact_id': 'מזהה איש קשר',
            'contact': 'איש קשר',
            'campaign_name': 'קמפיין',
            'user': 'נציג',
            'team': 'צוות',
            'start_time': 'תאריך תחילה',
            'end_time': 'תאריך סיום',
            'type': 'סוג',
            'status': 'סטטוס',
            'continue_reason_name': 'סיבת המשך תהליך',
            'continue_by': 'המשך תהליך ע״י',
            'end_reason_name': 'סיבת סיום תהליך',
            'comment': 'הערה'
        },

        'recordings': {
            'title': 'פירוט שיחות באירוע:'
        },

        'sum_area': {
            'title': 'התפלגות אירועים לפי הסינון הנוכחי:'
        }
    },

    'realtime_userinfo_report': {
        'title': 'דו״ח נציגים זמן אמת',

        'connection_close': 'החיבור לשרת נותק. האם ברצונך לחדש את החיבור?',
        'connection_close_error': 'החיבור לשרת נותק בשל שגיאה: {{error}}\nהאם ברצונך לחדש את החיבור?',

        'show_offline': 'הצג מנותקים',

        'columns': {
            'user_fullname': 'שם נציג',
            'username': 'שם משתמש',
            'team_name': 'צוות',
            'status': 'מצב שיחה',
            'status_duration': 'משך סטטוס',
            'call_count': 'סה״כ נסיונות שיחה',
            'answered_call_count': 'סה״כ שיחות שנענו',
            'saved_sessions': 'מספר תהליכים',
            'closed_orders': 'סה״כ הזמנות',
            'gross_call_duration': 'משך שיחה מצטבר',
            'net_call_duration': 'משך שיחה נטו מצטבר',
            'call_duration_avg': 'ממוצע זמן לשיחה',
            'personal_break_duration': 'זמן הפסקה אישית',
            'logged_in_duration': 'משך זמן במשמרת'
        },

        'statuses': {
            'logged_out': 'מנותק'
            , 'personal_break': 'בהפסקה ארוכה'
            , 'official_break': 'במשוב / תדריך'
            , 'short_break': 'בהפסקה קצרה'
            , 'backoffice_break': 'בק אופיס'
            , 'idle': 'לא בשיחה'
            , 'wait_for_call': 'בהמתנה לשיחה'
            , 'dialing': 'מחייג...'
            , 'ringing': 'מצלצל...'
            , 'in_outgoing_call': 'בשיחה יוצאת'
            , 'in_incoming_call': 'בשיחה נכנסת'
            , 'override': 'באנר'
        },

        'context_actions': {
            'live_listening': 'האזנה לשלוחה',
            'live_screen_monitor': 'צפיה במסך נציג',
            'personal_break': 'העבר להפסקה אישית',
            'official_break': 'העבר לתדריך / שיחת מנהל',
            'stop_break': 'הוצא מהפסקה',
            'logout': 'נתק מהמערכת'
        }
    },

    'userinfo_report': {
        'title': 'דו"ח פעילות נציגים יומי',

        'columns': {
            'user_id': 'מזהה נציג',
            'user_fullname': 'שם נציג',
            'username': 'שם משתמש',
            'team_name': 'צוות',
            'status': 'מצב שיחה',
            'status_duration': 'משך סטטוס',
            'call_count': 'סה״כ נסיונות שיחה',
            'answered_call_count': 'סה״כ שיחות שנענו',
            'saved_sessions': 'מספר תהליכים',
            'closed_orders': 'סה״כ הזמנות',
            'gross_call_duration': 'משך שיחה מצטבר',
            'net_call_duration': 'משך שיחה נטו מצטבר',
            'call_duration_avg': 'ממוצע זמן לשיחה',
            'personal_break_duration': 'זמן הפסקה אישית',
            'logged_in_duration': 'משך זמן במשמרת'
        }
    },

    'call_history_report': {
        'title': 'דוח הסטוריית שיחות',

        'filters': {
            'start_time': 'תאריך שיחה',
            'status': 'מצב שיחה',
            'gross_duration': 'משך שיחה',
            'net_duration': 'משך שיחה נטו',
        },

        'columns': {
            'user_fullname': 'נציג',
            'start_time': 'תאריך שיחה',
            'team_name': 'צוות',
            'status': 'מצב שיחה',
            'gross_duration': 'משך שיחה',
            'net_duration': 'משך שיחה נטו',
            'call_session_id': 'מזהה אירוע',
            'phone': 'מספר טלפון',
            'channel': 'שלוחה',
            'actions': 'פעולות',
            'play_record': 'נגן הקלטה',
            'play_record_button': 'נגן'
        }
    },

    'orders_report': {
        'title': 'דוח הזמנות',

        'columns': {
            'id': 'מזהה הזמנה',
            'campaign_name': 'קמפיין',
            'contact_id': 'מזהה איש קשר',
            'contact_name': 'איש קשר',
            'contact_idt': 'מספר מזהה',
            'status': 'מצב הזמנה',
            'created_at': 'נוצר בתאריך',
            'created_by': 'נוצר על ידי',
            'updated_at': 'עודכן בתאריך',
            'closed_at': 'נסגר בתאריך',
            'closed_by': 'נסגר על ידי',
            'closed_by_team_name': 'נסגר על ידי צוות',
            'actions': 'פעולות'
        }
    },

    'campaigns_report': {
        'title': 'מצב קמפיינים',
        'select_project': 'פרויקט:',
        'no_campaigns_message': 'לפרויקט זה אין קמפיינים, יש לבחור פרויקט אחר',
        'counted_continue_reason': 'סיבת המשך לספירה:',
        'campaign_name': 'שם הקמפיין',
        'contacts': 'אנשי קשר בקמפיין',
        'next_action_call': 'ממתינים לחלוקה',
        'next_action_continue': 'חזרה לאיש קשר',
        'next_action_end': 'סיימו תהליך',
        'total_to_call': 'נותרו לטיפול',
        'continue_reason': 'סיבת המשך תהליך ',
        'contacted': 'אנשי קשר שיצרו איתם קשר',
        'call_sessions': 'סך הכל תהליכים',
        'one_call': 'תהליך אחד',
        '2_calls': 'שני תהליכים',
        '3_calls_or_more': 'שלושה תהליכים ומעלה',
    },

    'yes_no_options': {
        'true': 'כן',
        'false': 'לא'
    },

    'default_alert_title': 'centerpoint',

    'empty_screen_message': 'ליצירת דו"ח נא השתמש בכפתור "הוספת מסנן"\nעל מנת להוסיף מסננים וכללים לדו"ח.',
    'choose_dates_filter_screen_message': 'תאריך שיחה הינו מסנן חובה, \nיש להוסיף על ידי לחיצה על הוספת מסנן - תאריך שיחה',
    'only_one_date_filter_screen_message': 'ניתן לסנן לפי יום אחד בלבד, יש להסיר את המסנן המיותר',
    'reload_after_filter_screen_message': 'לחץ על כפתור הרענון על מנת לטעון את הנתונים בהתאם למסננים המעודכנים.',

    'total_record_count_label': 'סה״כ רשומות:',

    'yes': 'כן',
    'no': 'לא',
    'cancel': 'ביטול',
    'ok': 'אוקיי',
    'save': 'שמירה',
    'edit': 'עריכה',
    'cancel_edit': 'סגור עריכה',
    'delete': 'מחיקה',
    'none': 'ללא',
    'refresh': 'ריענון'

}, {
    plural: function (count) {
        if (count === 0) return 'zero';
        if (count === 1) return 'one';
        if (count === 2) return 'two';
        return 'plural';
    }
}
];
